import { uuidModule } from "@/modules/uuid";
import { AssistantFollowUpModelData } from "@/store/assistant/types";
import { BaseSyncOperation } from "@/store/sync/operations/BaseSyncOperation";
import { generateDefaultOwnerScopes } from "@/store/sync/operations/helpers/common";
import { ICreateAssistantFollowUpOperation } from "@/store/sync/operations/types";
import { OptimisticSyncUpdate, SyncModelData } from "@/store/sync/types";

export class CreateAssistantFollowUpOperation extends BaseSyncOperation<ICreateAssistantFollowUpOperation> {
  get operationKind(): "CREATE_ASSISTANT_FOLLOW_UP" {
    return "CREATE_ASSISTANT_FOLLOW_UP";
  }

  public async generateOptimisticUpdates(): Promise<OptimisticSyncUpdate<SyncModelData>[]> {
    return [this.generateFollowUpUpdate()];
  }

  async triggerRecompute(): Promise<void> {
    await this.store.assistantFollowUps.recompute(this.payload.id);
  }

  private generateFollowUpUpdate(): OptimisticSyncUpdate<AssistantFollowUpModelData> {
    return {
      optimistic_update_id: uuidModule.generate(),
      locally_committed_at: this.committedAt,
      kind: "UPSERTED",
      value: {
        model_id: this.payload.id,
        model_kind: "ASSISTANT_FOLLOW_UP",
        model_version: 1,
        model_data: {
          space_account_id: this.store.spaceAccounts.myPersonalSpaceAccountId,
          assistant_id: this.payload.assistant_id,
          project_id: this.payload.project_id ?? null,
          task_id: this.payload.task_id ?? null,
          source_context_id: this.payload.source_context_id ?? null,
          content: this.payload.content,
          status: this.payload.status,
          scheduled_for: this.payload.scheduled_for,
          fired_at: null,
          completed_at: null,
          commitment_kind: this.payload.commitment_kind ?? null,
          due_at: this.payload.due_at ?? null,
          deadline_at: this.payload.deadline_at ?? null,
          trigger_type: this.payload.trigger_type ?? null,
          trigger_not_before: this.payload.trigger_not_before ?? null,
          trigger_not_after: this.payload.trigger_not_after ?? null,
          created_at: this.committedAt,
          updated_at: this.committedAt,
        },
        model_scopes: [generateDefaultOwnerScopes({ store: this.store })],
      },
    } as unknown as OptimisticSyncUpdate<AssistantFollowUpModelData>;
  }
}
